import { useEffect, useState } from "react";

/**
 * Thin reading progress indicator anchored to the LEFT edge of the viewport.
 * Non-intrusive: 2px wide, low-opacity clay track, filled with clay as the
 * user scrolls the current article.
 */
export function ReadingProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf = 0;
    const compute = () => {
      const doc = document.documentElement;
      const scrolled = window.scrollY;
      const max = (doc.scrollHeight || 0) - (window.innerHeight || 0);
      const p = max > 0 ? Math.min(1, Math.max(0, scrolled / max)) : 0;
      setProgress(p);
      raf = 0;
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(compute);
    };
    compute();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      aria-hidden
      className="fixed left-0 top-0 z-40 h-screen w-[2px] bg-clay/10 pointer-events-none"
    >
      <div
        className="w-full bg-clay origin-top transition-[height] duration-75"
        style={{ height: `${progress * 100}%` }}
      />
    </div>
  );
}
